import DateCard from "componentsv2/date/DateCardDouble";
import ToolButton from "componentsv2/button/ToolButton";
import IconButton from "componentsv2/button/IconButton";
import Filter from "componentsv2/card/CardsFilter";
import SearchWidget from "componentsv2/widgets/SearchWidget";
import MenuReports from "componentsv2/menu/MenuReports";
import MenuWizard from "componentsv2/menu/wizard/MenuWizard";
import { useTable } from "storev2/tableStore";

function CardToolbar(props) {
  const { layout, actions, handleView, data, storeId, kind, count } = props;
  const { reload } = useTable();
  const buttons = [];

  async function handleChange(value) {
    let dom;
    if (layout.filterDate) {
      dom = await layout.filterDate(value);
    }
    await reload(storeId, { date: dom ?? null });
  }

  if (layout.filterDate) {
    buttons.push(<DateCard key="filter-date" onChangeDate={handleChange} />);
  }
  if (actions.includes("add")) {
    if (kind === "big") {
      buttons.push(
        <ToolButton
          key="add"
          action="add"
          label="add_record"
          handleAction={handleView}
        />,
      );
    } else {
      buttons.push(
        <IconButton
          key="add"
          name="add"
          label="button_add"
          onClick={handleView}
        />,
      );
    }
  }

  const activeSearch = props.activeSearch || layout.activeSearch;
  const countRecords = data ? data.length : 0;

  const searchables = [];
  for (const [field, attrs] of Object.entries(layout.fields)) {
    if (attrs.searchable) {
      searchables.push({
        name: field,
        type: attrs.type,
      });
    }
  }

  let reports;
  let wizards;
  if (layout.toolbar_table) {
    if (layout.toolbar_table.reports) {
      reports = layout.toolbar_table.reports;
    }
    if (layout.toolbar_table.wizards) {
      wizards = layout.toolbar_table.wizards;
    }
  }

  return (
    <div id="toolbar" className="md:flex w-full md:w-fit gap-x-2 justify-end">
      {layout.filters && (
        <Filter layout={layout} countRecords={countRecords} storeId={storeId} />
      )}
      {activeSearch && (
        <div className="w-full md:w-75 my-auto max-md:absolute top-0 left-0">
          <SearchWidget layout={layout} storeId={storeId} count={count} />
        </div>
      )}
      {buttons && <div className="flex gap-x-2">{buttons}</div>}
      {wizards && <MenuWizard wizards={wizards} />}
      {reports && <MenuReports reports={reports} />}
    </div>
  );
}

export default CardToolbar;
